import { createEvent, sample } from "effector";
import { setPlayerCurrentTrackIndex, setPlayerCurrentTrackSourceIndex, setPlayerTrackQueue, } from "frontend/src/domain/player-track-queue";
import { playCurrentTrackInQueueAttempted } from "frontend/src/features/play-track-from-queue";
export var playSearchResultAttempted = createEvent();
playSearchResultAttempted.watch(console.log);
sample({
    clock: playSearchResultAttempted,
    fn: function (_a) {
        var tracks = _a.tracks, id = _a.id, title = _a.title, artist = _a.artist;
        return ({
            type: "search_result",
            tracks: tracks,
            attributes: { id: id, title: title, artist: artist },
        });
    },
    target: setPlayerTrackQueue,
});
sample({
    clock: playSearchResultAttempted,
    fn: function () { return 0; },
    target: setPlayerCurrentTrackSourceIndex,
});
sample({
    clock: playSearchResultAttempted,
    fn: function (_a) {
        var startAtTrackIndex = _a.startAtTrackIndex;
        return startAtTrackIndex;
    },
    target: setPlayerCurrentTrackIndex,
});
sample({
    clock: playSearchResultAttempted,
    target: playCurrentTrackInQueueAttempted,
});
